import ProjectEntriesStructureConfig from './ProjectEntriesStructureConfig'

export default ProjectEntriesStructureConfig
